import type { TFunction } from "i18next";
import type { CustomerContactDto } from "@hisense/shared";

/**
 * Nhãn một người liên hệ trong ô chọn người nhận (báo giá, PI, thẻ mẫu): "Tên · điện thoại · email". Liên hệ riêng tư
 * (30/09/2026) chỉ quản trị viên nhận được, và mang thêm "(chỉ quản trị viên)" để họ biết đang chép số của ai lên một chứng từ
 * cả đội đọc.
 */
export function contactOptionLabel(c: Pick<CustomerContactDto, "name" | "phone1" | "email" | "isPrivate">, t: TFunction): string {
  const label = [c.name, c.phone1, c.email].filter(Boolean).join(" · ");
  return c.isPrivate ? `${label}${t("customers.privateContactSuffix")}` : label;
}
